import { render, staticRenderFns } from "./CreateMairaQuestionnaire.vue?vue&type=template&id=490234be&scoped=true"
import script from "./CreateMairaQuestionnaire.vue?vue&type=script&lang=js"
export * from "./CreateMairaQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./CreateMairaQuestionnaire.vue?vue&type=style&index=0&id=490234be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490234be",
  null
  
)

export default component.exports